<form [formGroup]="JobForm" #JobsForm="ngForm" (ngSubmit)="onSubmit()">
    <div class="card full-dashboard-bgcover">
        <div class="card-body">
            <div class="add-job-sections common-popup-ui">
                <h5>Job Details</h5>
                <div class="row">
                    <div class="col-lg-6 col-12">
                        <div class="form-group mb-4">
                            <label>{{jobConstant.TITLE}}<span class="form-control-danger">*</span></label>
                            <input matInput oninput="this.value = this.value.replace(/^\s+/g, '')" placeholder="Title"
                                formControlName="title" class="form-control" />
                            <span class="text-danger"
                                *ngIf="JobsForm.submitted && jobFormControl['title'].errors?.['required']">
                                {{JobErrorPageMessage.TitleIsRequired}}
                            </span>
                            <span class="text-danger"
                                *ngIf="jobFormControl['title'].errors?.['maxlength']">
                                {{JobErrorPageMessage.TitleLengthValidation}}
                            </span>
                        </div>
                    </div>
                    <div class="col-lg-6 col-12">
                        <div class="form-group mb-4 matselectfield">
                            <label>{{jobConstant.STATE}}<span class="form-control-danger">*</span></label>
                            <div class="input-group">
                                <mat-form-field>
                                    <mat-select class="form-control" id="style" formControlName="StateId"
                                        [attr.disabled]="true"
                                        (selectionChange)="getCityByStateId(JobForm.get('StateId')?.value)"
                                        placeholder="Select State" #singleSelect>
                                        <mat-option>
                                            <ngx-mat-select-search placeholderLabel="Search State..."
                                                noEntriesFoundLabel="'no matching state found'"
                                                [formControl]="FilterCtrl"></ngx-mat-select-search>
                                        </mat-option>
                                        <mat-option *ngFor="let item of filteredData | async" [value]="item.id">
                                            {{item.value}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <span class="text-danger"
                                    *ngIf="JobsForm.submitted && jobFormControl['StateId'].errors?.['required']">
                                    {{JobErrorPageMessage.StateIsRequired}}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-12">
                        <div class="form-group mb-4 matselectfield">
                            <label>{{jobConstant.CITY}}<span class="form-control-danger">*</span></label>
                            <div class="input-group">
                                <mat-form-field>
                                    <mat-select class="form-control" id="style" formControlName="CityId"
                                        [disabled]="JobForm.get('CityId')?.disabled === true" placeholder="Select City"
                                        #singleSelect
                                        [ngClass]="{'disabled-dropdown': JobForm.get('CityId')?.disabled=== true}">
                                        <mat-option>
                                            <ngx-mat-select-search placeholderLabel="Search City..."
                                                noEntriesFoundLabel="'no matching city found'"
                                                [formControl]="CityFilterCtrl"></ngx-mat-select-search>
                                        </mat-option>
                                        <mat-option *ngFor="let item of cityFilteredData | async" [value]="item.id">
                                            {{item.value}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <span class="text-danger"
                                    *ngIf="JobsForm.submitted && jobFormControl['CityId'].errors?.['required']">
                                    {{JobErrorPageMessage.CityIsRequired}}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-12">
                        <div class="form-group mb-4 ">
                            <label>{{jobConstant.TAGS}}<span class="form-control-danger">*</span></label>
                            <div class="input-group">
                                <ng-multiselect-dropdown class="dropdown-btn form-control form-control-lg"
                                    [placeholder]="'Select Tags'" [settings]="dropdownSettings" [data]="dropdownList"
                                    formControlName="JobTypeId" (onSelect)="onTagSelect($event)"
                                    (onSelectAll)="onTagSelectAll($event)"
                                    (onDeSelect)="onItemDeSelectQuestionSet($event)"
                                    (onDeSelectAll)="onUnSelectAllQuestionSet()">
                                </ng-multiselect-dropdown>
                                <span class="text-danger"
                                    *ngIf="JobsForm.submitted && jobFormControl['JobTypeId'].errors?.['required']">
                                    {{JobErrorPageMessage.TagIsRequired}}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-12">
                        <div class="form-group mb-4 matselectfield">
                            <label>{{jobConstant.TECHNOLOGY}}<span class="form-control-danger">*</span></label>
                            <div class="input-group">
                                <mat-form-field>
                                    <mat-select class="form-control" id="style" formControlName="TechnologyPreferenceId"
                                        [attr.disabled]="true" placeholder="Select Technology" #singleSelect>
                                        <mat-option>
                                            <ngx-mat-select-search placeholderLabel="Search Technology..."
                                                noEntriesFoundLabel="'no matching technology found'"
                                                [formControl]="technologyFilterCtrl"></ngx-mat-select-search>
                                        </mat-option>
                                        <mat-option *ngFor="let item of technologyFilteredData | async"
                                            [value]="item.id">
                                            {{item.value}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                                <span class="text-danger"
                                    *ngIf="JobsForm.submitted && jobFormControl['TechnologyPreferenceId'].errors?.['required']">
                                    {{JobErrorPageMessage.TechnologyIsRequired}}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6 col-12">
                        <div class="form-group mb-4">
                            <label>{{ jobConstant.APPLY_USER }}<span class="form-control-danger">*</span></label>
                            <input matInput placeholder="No of Vacancies"
                                oninput="this.value = this.value.replace(/^\s+/g, '')" maxlength="3" 
                                formControlName="Applicant" class="form-control"
                                onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" />
                            <span class="text-danger"
                                *ngIf="JobsForm.submitted && jobFormControl['Applicant'].errors?.['required']">
                                {{JobErrorPageMessage.VacanciesIsRequired}}
                            </span>
                            <span class="text-danger"
                                *ngIf="JobsForm.submitted && jobFormControl['Applicant'].errors?.['pattern']">
                                {{JobErrorPageMessage.ValidVacanciesNumber}}
                            </span>
                            <span class="text-danger"
                                *ngIf="JobsForm.submitted && jobFormControl['Applicant'].errors?.['min']">
                                {{JobErrorPageMessage.VacancyValueGreaterThanZero}}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-12">
                        <div class="form-group mb-4">
                            <label>{{jobConstant.MIN_EXPERIENCE}}<span> (Year)</span><span
                                    class="form-control-danger">*</span></label>
                            <input matInput placeholder="Min Experience" type="number" min="0"
                                formControlName="MinExperience" class="form-control"
                                onkeypress="return(event.charCode != 45 && event.charCode != 8 && (event.charCode == 0 || event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)))" />
                            <span class="text-danger"
                                *ngIf="JobsForm.submitted && jobFormControl['MinExperience'].errors?.['required']">
                                {{JobErrorPageMessage.MinExperienceIsRequired}}
                            </span>
                            <span class="text-danger"
                                *ngIf="JobsForm.submitted && jobFormControl['MinExperience'].errors?.['max'] && !(jobFormControl['MinExperience'].errors?.['pattern'])">
                                {{JobErrorPageMessage.MinExperienceValueLessThanEqualTo}}
                            </span>
                            <span class="text-danger"
                                *ngIf="JobsForm.submitted && jobFormControl['MinExperience'].errors?.['min'] && !(jobFormControl['MinExperience'].errors?.['pattern'])">
                                {{JobErrorPageMessage.MinExperienceValueGreaterThanZero}}
                            </span>
                            <span class="text-danger"
                                *ngIf="JobsForm.submitted && jobFormControl['MinExperience'].errors?.['pattern'] ">
                                {{JobErrorPageMessage.MaxOneDecimalAllowed}}
                            </span>
                        </div>
                    </div>
                    <div class="col-lg-6 col-12">
                        <div class="form-group mb-4">
                            <label>{{ jobConstant.MIN_SALARY }}<span> (L.P.A)</span><span
                                    class="form-control-danger">*</span></label>
                            <input matInput maxlength="6" placeholder="Minimum Salary" type="number" min="0.01"
                                formControlName="MinimumSalary" class="form-control"
                                onkeypress="return (event.charCode != 45 && event.charCode != 8 && (event.charCode == 0 || event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)))" />
                            <span class="text-danger"
                                *ngIf="JobsForm.submitted && jobFormControl['MinimumSalary'].errors?.['required']">
                                {{JobErrorPageMessage.MinSalaryIsRequired}}
                            </span>
                            <span class="text-danger"
                                *ngIf="JobsForm.submitted && jobFormControl['MinimumSalary'].errors?.['min'] && !(jobFormControl['MinimumSalary'].errors?.['pattern'])">
                                {{JobErrorPageMessage.SalaryValueGreaterThanZero}}
                            </span>
                            <span class="text-danger"
                                *ngIf="JobsForm.submitted && jobFormControl['MinimumSalary'].errors?.['max'] && !(jobFormControl['MinimumSalary'].errors?.['pattern'])">
                                {{JobErrorPageMessage.ValueLessThanEqualTo}}
                            </span>
                            <span class="text-danger"
                                *ngIf="JobsForm.submitted && jobFormControl['MinimumSalary'].errors?.['pattern']">
                                {{JobErrorPageMessage.MaxTwoDecimalAllowed}}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6 col-12">
                        <div class="form-group mb-4">
                            <label>{{jobConstant.MAX_SALARY}} <span> (L.P.A)</span><span
                                    class="form-control-danger">*</span></label>
                            <input matInput placeholder="Maximum Salary" type="number" min="0.01"
                                formControlName="MaximumSalary" (keyup)="validSalary()" class="form-control test"
                                onkeypress="return (event.charCode != 45 && event.charCode != 8 && (event.charCode == 0 || event.charCode == 46 || (event.charCode >= 48 && event.charCode <= 57)))" />
                            <span class="text-danger"
                                *ngIf="JobsForm.submitted && jobFormControl['MaximumSalary'].errors?.['required']">
                                {{JobErrorPageMessage.MaxSalaryIsRequired}}
                            </span>
                            <span class="text-danger"
                                *ngIf="JobsForm.submitted && jobFormControl['MaximumSalary'].errors?.['min'] && !(jobFormControl['MaximumSalary'].errors?.['pattern'])">
                                {{JobErrorPageMessage.SalaryValueGreaterThanZero}}
                            </span>
                            <span class="text-danger"
                                *ngIf="JobsForm.submitted && jobFormControl['MaximumSalary'].errors?.['max'] && !(jobFormControl['MaximumSalary'].errors?.['pattern'])">
                                {{JobErrorPageMessage.ValueLessThanEqualTo}}
                            </span>
                            <span class="text-danger"
                                *ngIf="JobsForm.submitted && jobFormControl['MaximumSalary'].errors?.['pattern']">
                                {{JobErrorPageMessage.MaxTwoDecimalAllowed}}
                            </span>
                            <span class="text-danger"
                                *ngIf="JobsForm.submitted &&  !jobFormControl['MaximumSalary'].errors?.['required'] && !isValidSalary && !(jobFormControl['MaximumSalary'].errors?.['min']) && !(jobFormControl['MaximumSalary'].errors?.['pattern'])">
                                {{JobErrorPageMessage.MaxSalaryIsNotLessThanMinSalary}}</span>
                        </div>
                    </div>
                    <div class="col-sm-12">
                        <div class="form-group mb-4 biggertextarea">
                            <label>{{jobConstant.JOB_DESCRIPTIONS}}<span class="form-control-danger">*</span></label>
                            <ckeditor [editor]="Editor" formControlName="Description"></ckeditor>
                            <span class="text-danger"
                                *ngIf="JobsForm.submitted && jobFormControl['Description'].errors?.['required']">
                                {{JobErrorPageMessage.JobDescriptionIsRequired}}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-sm-12">
                        <div class="form-group mb-4 biggertextarea">
                            <label>{{jobConstant.RESPONSIBILITIES}}<span class="form-control-danger">*</span></label>
                            <ckeditor [editor]="Editor" formControlName="Responsblities" class="ckeditor-container">
                            </ckeditor>
                            <span class="text-danger"
                                *ngIf="JobsForm.submitted && jobFormControl['Responsblities'].errors?.['required']">
                                {{JobErrorPageMessage.ResponsblitiesIsRequired}}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="modal-footer justify-content-center border-0 px-2 py-0 mt-4">
                        <button type="submit" class="btn btn-primary common-button mx-2"><span>{{ jobId > 0 ? 'Update' :
                                'Save' }}</span></button>
                        <button type="button" class="btn btn-border common-button mx-2"
                            (click)="onCancel()">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>